import React from 'react';
import './AgGridTableHeader.css';

const AgGridTableHeader = (props) => {
  return <div className="customer-header-ag-grid">{props.displayName}</div>;
};

export default AgGridTableHeader;
